import React from "react"
import { Box, Grid } from "@mui/material"
import Card from "./Card"

import { useSelector, useDispatch } from "react-redux"
import { getAllPosts } from "../features/posts/postSlice"

const RecentPosts = () => {
  const dispatch = useDispatch()
  const { posts, isLoading } = useSelector((state) => state.posts)
  React.useEffect(() => {
    dispatch(getAllPosts())
  }, [dispatch])

  if (isLoading) return "Loading..."
  return (
    <Box>
      <Grid container rowSpacing={1} columnSpacing={1}>
        <Grid item md={12}>
          <Card post={posts && posts[0]} />
        </Grid>

        {posts &&
          posts.length > 0 &&
          posts.slice(1, 5).map((post) => (
            <Grid item xs={12} md={6} key={post._id}>
              <Card post={post} />
            </Grid>
          ))}
      </Grid>
    </Box>
  )
}
export default RecentPosts
